export default __webpack_public_path__ + "static/media/a018-5.52985c50.svg";